function guardedCall(lockObj, data, fn) {
    if (lockObj.guard)
        return;
    try {
        lockObj.guard = true;
        lockObj.data = data;
        fn();
    }
    finally {
        lockObj.guard = false;
        lockObj.data = null;
    }
}
function LoggerErrorHandler() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const logger = this;
    const loggerError = { guard: false, data: null };
    const loggerDoubleError = { guard: false, data: null };
    function onLoggerError(event) {
        if (!event)
            return;
        const isRealError = typeof event.type === 'string' && event.type.indexOf('error') >= 0;
        const msg = ['logger', event.source, event.type].join('.');
        if (!loggerError.guard) {
            // First attempts to log a logger failure
            // Make sure we don't attempt to fully log the same error multiple times
            guardedCall(loggerError, event, function loggerErrorEventHandler() {
                // This should allow us to track down what user action caused the logger failure
                const logFn = isRealError ? logger.error : logger.info;
                logFn.call(logger, msg, event.detail);
            });
        }
        else {
            // Logger Failure Inception!
            // Report as best as we can outside of the badly broken logger message parser
            // Make sure we don't get into a logger error recursion
            guardedCall(loggerDoubleError, event, function loggerDoubleErrorEventHandler() {
                const error = loggerError.data && loggerError.data.detail
                    ? loggerError.data.detail.error
                    : null;
                const doubleError = event.detail ? event.detail.error : null;
                const rawErrorEvent = {
                    level: 'error',
                    arguments: [msg, 'error=', error, 'doubleError=', doubleError],
                };
                // Log to console
                logger.signals.onRawLog.dispatch(rawErrorEvent);
                logger.signals.onLineLog.dispatch(rawErrorEvent);
                // And try remotely as well
                const logEntry = {
                    seqNum: logger.root.seqNum++,
                    level: 'error',
                    timestamp: new Date().toJSON(),
                    msg: msg,
                };
                if (error) {
                    logEntry['error.name'] = error.name;
                    logEntry['error.message'] = error.message;
                    if (error.stack)
                        logEntry['error.stack'] = error.stack;
                }
                if (doubleError) {
                    logEntry['doubleError.name'] = doubleError.name;
                    logEntry['doubleError.message'] = doubleError.message;
                    if (doubleError.stack)
                        logEntry['doubleError.stack'] = doubleError.stack;
                }
                logger.signals.onFormattedLog.dispatch({
                    entry: logEntry,
                });
            });
        }
    }
    logger.signals.onError.add(onLoggerError);
}
export default {
    pluginName: 'loggerErrorHandler',
    dependencies: ['logger'],
    rootInit: LoggerErrorHandler,
};
//# sourceMappingURL=logger_error_handler.js.map